// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"2a4cf392","76":"cbdd4c69","151":"57588039","197":"88f55b50","213":"9bbd9b72","369":"9b2b4c46","370":"e03d1b74","371":"ce950d68","459":"d5e7ed32","670":"18cead57","807":"ca914972"}[chunkId] + ".chunk.js";
};